const KEY = 'hive.grid.game';

/** The game Grid last showed on this device, so /grid reopens it. */
export function lastGameSlug(): string {
  try {
    return localStorage.getItem(KEY) || 'studio';
  } catch {
    return 'studio';
  }
}

export function rememberGameSlug(slug: string): void {
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    // Storage can be unavailable (private windows); Grid just opens Studio next time.
  }
}
